'use client';

import { BREAKPOINT } from '@/constants';
import { useEffect, useState } from 'react';

/**
 * メディアクエリを使用して、画面の幅を取得する
 * @param query string メディアクエリのクエリ文字列
 * @returns boolean メディアクエリに一致するかどうか
 */
const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    setMatches(mediaQuery.matches);

    const handler = (e: MediaQueryListEvent) => setMatches(e.matches);

    mediaQuery.addEventListener('change', handler);
    return () => mediaQuery.removeEventListener('change', handler);
  }, [query]);

  return matches;
};

/**
 * スマホ判定用フック
 *
 * 判定に使用するブレイクポイントは {@link BREAKPOINT.SP}
 * @returns boolean スマホかどうか
 *
 * @example
 * const isSp = useIsSp();
 * if (isSp) {
 *   console.log('スマホです');
 * }
 *
 */
export const useIsSp = () => {
  return useMediaQuery(`(max-width: ${BREAKPOINT.SP}px)`);
};
